import { render, staticRenderFns } from "./ActivityNoticeBanner.vue?vue&type=template&id=2339f99d&scoped=true&"
import script from "./ActivityNoticeBanner.vue?vue&type=script&lang=ts&"
export * from "./ActivityNoticeBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2339f99d",
  null
  
)

export default component.exports